export default "__VITE_ASSET__0330e4fd__"